import { render } from "./CoReg_Page.vue?vue&type=template&id=5efa753f"
import script from "./CoReg_Page.vue?vue&type=script&lang=js"
export * from "./CoReg_Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__